export default {
	label: "Suche",
	placeholder: "Nach Produkt oder Marke suchen",
	productListLabel: "Die besten Suchergebnisse für Ihre Anfrage",
	popularSearchLabel: "Beliebte Suchanfragen",
	close: "Schließen"
};
